jQuery(document).ready(function($){
	$(window).on('scroll', function(){
			if ($(window).scrollTop() > 30){
		$('body').addClass('float_active');
			}else {
		$('body').removeClass('float_active');
			}
	});

	setInterval(()=>{
		if($('body').hasClass('cart_open')){
			var header_height = $('#cart_sidebar_header').outerHeight();
			var cart_footer = $('#cart_footer').outerHeight();
			var elementsHeight = header_height + cart_footer;

			$('#cart_body').css('--elementsHeight', elementsHeight + 'px');
		}
	}, 500);
	 
	let vh = window.innerHeight * 0.01;
	document.documentElement.style.setProperty('--vh', `${vh}px`);
	window.addEventListener('resize', () => {
		let vh = window.innerHeight * 0.01;
		document.documentElement.style.setProperty('--vh', `${vh}px`);
	});
		
	var Shopify = Shopify || {};
	Shopify.money_format = "${{amount}}";

	Shopify.formatMoney = function(cents, format) {
		if (typeof cents == 'string') { cents = cents.replace('.',''); }
		
		var value = '';
		var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
		var formatString = (format || this.money_format);
	
		function defaultOption(opt, def) {
			return (typeof opt == 'undefined' ? def : opt);
		}
	
		function formatWithDelimiters(number, precision, thousands, decimal) {
			precision = defaultOption(precision, 2);
			thousands = defaultOption(thousands, ',');
			decimal   = defaultOption(decimal, '.');
		
			if (isNaN(number) || number == null) { return 0; }
		
			number = (number/100.0).toFixed(precision);
		
			var parts   = number.split('.'),
				dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
				cents   = parts[1] ? (decimal + parts[1]) : '';
		
			return dollars + cents;
		}
	
		switch(formatString.match(placeholderRegex)[1]) {
			case 'amount':
				value = formatWithDelimiters(cents, 2);
				break;
			case 'amount_no_decimals':
				value = formatWithDelimiters(cents, 0);
				break;
			case 'amount_with_comma_separator':
				value = formatWithDelimiters(cents, 2, '.', ',');
				break;
			case 'amount_no_decimals_with_comma_separator':
				value = formatWithDelimiters(cents, 0, '.', ',');
				break;
		}
	
		return formatString.replace(placeholderRegex, value);
	};

		//data-click-action
	$(document).on('click', '[data-click-action]', function(event){
		event.preventDefault();

		var element = $(this),
			actions = $(this).data('click-action');

		$.each(actions, function(action, action_params){
			if(action && typeof $.fn[action] === 'function'){
				$.fn[action](action_params, element);
			}else{
				console.log('Action '+ action +' not found');
			}
		});
	});
	
	$.fn.activatePasswordRecover = function(args, form){
		var active = $('#login_page').data('active');
		console.log(active);
		
		switch(active){
		case 'login':
			$('#login_page').attr('data-active', 'recover');
			$('#login_page').data('active', 'recover');
			$('#login_form_wrapper').hide();
			$('#recover_form_wrapper').show();
		break;
		case 'recover':
			$('#login_page').attr('data-active', 'login');
			$('#login_page').data('active', 'login');
			$('#login_form_wrapper').show();
			$('#recover_form_wrapper').hide();
		break;
		}
	};
	
	$(document).on('click', '.suport_view_all', function(event){
		var support_item = $(this).closest('.support_item_content');
		
		if($(this).hasClass('open')){
			$(support_item).find('.extra_list').slideUp();
			$(this).text('Collapse').removeClass('open');
		}else{
			$(support_item).find('.extra_list').slideDown();
			$(this).text('Collapse').addClass('open');
		}
	});
	
	$(document).on('click', '.suport_view_all', function(event){
		var support_item = $(this).closest('.support_item_content');
		
		if($(this).hasClass('open')){
			$(support_item).find('.extra_list').slideUp();
			$(this).text('Collapse').removeClass('open');
		}else{
			$(support_item).find('.extra_list').slideDown();
			$(this).text('Collapse').addClass('open');
		}
	});
	
	//TESTIMONIALS
	const testimonials_slider = new Swiper('.testimonials_slider', {
		loop: true,
		navigation: {
		nextEl: '.swiper-button-next',
		prevEl: '.swiper-button-prev',
		},
	});

	//product_materials_carousel
	const product_materials_carousel = new Swiper('.product_materials_carousel', {
		slidesPerView: 8,
		spaceBetween: 30,
		noSwiping:true,
		allowTouchMove: false,
		shortSwipes:false,
		simulateTouch:false,
		breakpoints: {
			0: {
				slidesPerView: 2,
				spaceBetween: 10
			},
			600: {
				slidesPerView: 4,
				spaceBetween: 10
			},
			800: {
				slidesPerView: 5,
				spaceBetween: 10
			},
			1000: {
				slidesPerView: 8,
				spaceBetween: 30
			},
		},
		navigation: {
			nextEl: '.materials-next',
			prevEl: '.materials-prev',
		},
	});

	//data-account-tab
	$(document).on('click', '[data-account-tab]', function(event){
		var tab = $(this).data('account-tab');

		$('.account_menu_item').removeClass('current');
		$(this).addClass('current');
		
		$('.main_account_content').removeClass('active');
		$('#'+ tab).addClass('active');
	});

	//OPEN CHANGE PASSWORD
	$(document).on('click', '#open_change_password', function(event){
		event.preventDefault();
		$('#change_password_modal').addClass('active');
	});

	//CLOSE CHANGE PASSWORD
	$(document).on('click', '#close_change_password', function(event){
		event.preventDefault();
		$('#change_password_modal').removeClass('active');
	});

	//same_as_billing
	$(document).on('click', '#same_as_billing', function(event){
		if($(this).is(':checked')){
			$('#shipping_address').addClass('d-none').removeClass('d-block');
		}else{
			$('#shipping_address').addClass('d-block').removeClass('d-none');
		}
	});

	/*** FETCH HELPERS ***/
	// Shopify Ajax API request (e.g. 'cart/add.js') with a JSON body. Resolves with the parsed response.
	// Using fetch (not XHR) lets calculator-cart-validator.js reprice custom sticker lines on cart/change.
	async function cartRequest(path, data){
		const response = await fetch(window.Shopify.routes.root + path, {
			method: data ? 'POST' : 'GET',
			headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
			body: data ? JSON.stringify(data) : undefined,
		});

		if(!response.ok){
			const error = await response.json().catch(() => ({}));
			throw new Error(error.description || error.message || 'Cart request failed: HTTP ' + response.status);
		}

		return response.json();
	}

	// External (icepick) request. $.param keeps jQuery's form encoding, including nested `properties[...]` keys.
	// Resolves with the response text; callers parse it as before.
	async function formRequest(url, method, data){
		const response = await fetch(url, {
			method: method || 'POST',
			headers: data ? { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' } : undefined,
			body: data ? $.param(data) : undefined,
		});

		if(!response.ok){
			const error = new Error('Request failed: HTTP ' + response.status);
			error.responseText = await response.text().catch(() => '');
			throw error;
		}

		return response.text();
	}

	//reorder_button
	$(document).on('click', '#reorder_button', async function(event){
		event.preventDefault();
		var orderId = $('#order_id').val(),
			now = $.now();
		
		orderId = orderId.replace(/\D/g,'');
		$('#cart_loader').addClass('loading');

		try{
			const obj = JSON.parse(await formRequest('https://icepick.co/api/shopify/orders.php?v='+ now +'&order_id='+orderId, 'GET'));
			
			if(obj.status != 'success'){
				alert(obj.error || 'An unexpected error occurred, please verify your data and try again');
				return;
			}

			const items = obj.items.filter((element) => element.id !== 0 && element.id != null);

			await cartRequest('cart/add.js', { items: items });
			//ADD NOTE TO THE CART
			await cartRequest('cart/update.js', { note: 'Re-Ordered from order #' + orderId });

			window.location = '/checkout';
		}catch(error){
			console.error(error);
			alert('An unexpected error occurred, please verify your data and try again');
		}finally{
			$('#cart_loader').removeClass('loading');
		}
	});

	//MOBILE MENU TRIGGER
	$(document).on('click', '#menu_trigger', function(event){
		if($('body').hasClass('menu_open')){
			$('body').removeClass('menu_open');
			$('#header_mobile_menu_wrapper').slideUp();      
		}else{
			$('body').addClass('menu_open');
			$('#header_mobile_menu_wrapper').slideDown(); 
		}
	});

	/*** CART SIDEBAR ***/
	// The cart UIs on the page — the drawer (snippets/cart_sidebar, inside the footer section) and
	// the cart page section — re-rendered through the Section Rendering API, swapping in just their
	// cart markup. Their handlers are delegated, so they keep working on the new markup.
	var CART_UIS = ['#cart_sidebar_wrapper', '.sd-cart-wrapper'];

	$.fn.refreshCart = async function(){
		var targets = CART_UIS.map(function(selector){
			var element = document.querySelector(selector),
				section = element && element.closest('.shopify-section');
			return { selector: selector, element: element, section: section && section.id.replace(/^shopify-section-/, '') };
		}).filter(function(target){ return target.section; });
		if(!targets.length) return;

		var url = new URL(window.location.href);
		url.searchParams.set('sections', targets.map(function(target){ return target.section; }).join(','));
		const response = await fetch(url);
		if(!response.ok) throw new Error('Cart re-render failed: HTTP ' + response.status);
		const sections = await response.json();

		targets.forEach(function(target){
			var html = sections[target.section],
				next = html && new DOMParser().parseFromString(html, 'text/html').querySelector(target.selector);
			if(next) target.element.replaceWith(next);
		});
	};

	// After an add to cart: show the drawer with the new line, instead of leaving for /cart.
	$.fn.openCartDrawer = async function(){
		try{
			await $.fn.refreshCart();
			$('body').addClass('cart_open');
		}catch(error){
			console.error(error);
			window.location = '/cart';
		}finally{
			$('#cart_loader').removeClass('loading');
		}
	};

	//add_stakes_form
	$(document).on('click', '.add_stakes_form #add_main_product', function(event){
		event.preventDefault();

		if($('#stakes_input').val() == 'yes'){
			var quantity = $('#option2').find(':selected').data('qty-value');
			
			fetch('https://www.stickydeals.com/cart/add?id=43710925865160&quantity='+quantity)
			.then(response => {
				$('.add_stakes_form')[0].requestSubmit();
			})
			.catch((error) => {
				console.error('Error:', error);
			});
		}else{
			$('.add_stakes_form')[0].requestSubmit();
		}
	});

	// Product forms post to /cart/add natively, which lands on the cart page: add over Ajax and
	// open the drawer instead. Listens on window, so the jQuery submit handlers (delegated from
	// document) run first: a form they've already taken over or stopped is left alone.
	window.addEventListener('submit', async function(event){
		var form = event.target;
		if(event.defaultPrevented || !(form instanceof HTMLFormElement) || form.closest('sd-product-form')) return;
		if(!/\/cart\/add$/.test(new URL(form.action, window.location.href).pathname)) return;

		event.preventDefault();
		$('#cart_loader').addClass('loading');

		try{
			const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
				method: 'POST',
				headers: { 'Accept': 'application/json' },
				body: new FormData(form, event.submitter),
			});

			if(!response.ok){
				const error = await response.json().catch(() => ({}));
				throw new Error(error.description || error.message || 'Could not add to cart, please try again.');
			}

			await $.fn.openCartDrawer();
		}catch(error){
			$('#cart_loader').removeClass('loading');
			alert(error.message);
		}
	});

	// deals form
	$(document).on('submit', '.deals_form', function(event){
		if($('#cart_body').find('.is_deal').length > 0){
			event.preventDefault();
			alert('It is only possible to buy this product once. It is already in your cart');
			return;
		}
	});

	
	//data-reorder
	$(document).on('click', '[data-reorder]', async function(event){
		const orderId = $(this).data('reorder');

		try{
			const obj = JSON.parse(await formRequest('https://icepick.co/api/shopify/orders.php?order_id='+orderId, 'GET'));

			if(obj.status == 'success'){
				await cartRequest('cart/add.js', { items: obj.items });
				await $.fn.openCartDrawer();
			}
		}catch(error){
			console.error(error);
		}
	});

	//data-add-product
	$(document).on('click', '[data-add-product]', async function(event){
		var product_id = parseInt($(this).data('add-product'));

		try{
			await cartRequest('cart/add.js', { items: [{ id: product_id, quantity: 1 }] });
			await $.fn.openCartDrawer();
		}catch(error){
			console.error(error);
		}
	});

	//cart_trigger
	$(document).on('click', '#cart_trigger', function(event){
		$('body').addClass('cart_open');
	});

	//data-close-cart
	$(document).on('click', '[data-close-cart]', function(event){
		event.preventDefault();
		$('body').removeClass('cart_open');
	});

	$.fn.remove_cart_item = async function(item_id){
		$('[data-item-id="'+ item_id +'"]').remove();

		try{
			const cart = await cartRequest('cart/change.js', { id: item_id, quantity: 0 });

			$('.subtotal_amount').text(Shopify.formatMoney(cart.total_price));
			$('.grand_total_amount').text(Shopify.formatMoney(cart.total_price));
			$('[data-cart-count]').text(cart.items.length);

			if (cart.items.length == 0) {
				$('#cart_sidebar_wrapper').addClass('cart_is_empty');
			}

			if($('#cart_body').find('#selected_rush_option').length > 0){
				var rush_item = $('#cart_body').find('#selected_rush_option').closest('.cart_item'),
					rush_id = $(rush_item).attr('data-item-id');
				
				$.fn.remove_cart_item(rush_id);
			}else{
				$('.rush_option_accordeon').show();
			}
		}catch(error){
			console.error(error);
		}
	}

	//remove_cart_item
	$(document).on('click', '[data-remove-cart-item]', function(event){
		var item = $(this).closest('.cart_item'),
			id = $(item).attr('data-item-id');

		$.fn.remove_cart_item(id);
	});

	//sidebar_qty
	$(document).on('change', '.qty', async function(event){
		var item = $(this).closest('.cart_item'),
			id = $(item).attr('data-item-id'),
			qty = $(this).val(),
			min = parseInt($(this).attr('min'));

		if(!$(item).hasClass('sample-sticker-pack')){
			if(qty < min){
				$(this).val(min);
				qty = min;
			}
		}

		$('#cart_sidebar').addClass('loading');
			
		setTimeout(()=>{
			$('#cart_sidebar').removeClass('loading');

			if($('#cart_body').find('#selected_rush_option').length > 0){
				var rush_item = $('#cart_body').find('#selected_rush_option').closest('.cart_item'),
					rush_id = $(rush_item).attr('data-item-id');
				
				$.fn.remove_cart_item(rush_id);
			}
		}, 2000);

		// The line index is read before the request: it doesn't change, while the
		// key does when calculator-cart-validator.js reprices the line's properties.
		var line_index = $('#cart_body .cart_item').index(item);

		try{
			const cart = await cartRequest('cart/change.js', { id: id, quantity: qty });
			const line = cart.items[line_index];

			if(line_index > -1 && line){
				$(item).attr('data-item-id', line.key);
				$(item).find('[data-line-price]').text(Shopify.formatMoney(line.final_line_price));
			}

			$('.subtotal_amount').text(Shopify.formatMoney(cart.total_price));
			$('.grand_total_amount').text(Shopify.formatMoney(cart.total_price));
			$('[data-cart-count]').text(cart.items.length);

			if(!$(item).find('.orders_text').is('[data-custom-sticker]')){
				$(item).find('.orders_text').text(qty > 1 ? 'Orders' : 'Order');
			}
		
			if(cart.item_count == 0){
				$('#cart_sidebar_wrapper').addClass('cart_is_empty');
			}
		}catch(error){
			console.error(error);
		}
	});

	//product_notes
	$(document).on('change', '.product_notes', async function(event){
		var item = $(this).closest('.cart_item'),
			id = $(item).attr('data-item-id'),
			notes = $(this).val();

		try{
			const cart = await cartRequest('cart.js');
			const line_index = cart.items.findIndex((line) => line.key == id);
			const line = cart.items[line_index];
			if(!line) return;

			line.properties.Notes = notes;

			const updated_cart = await cartRequest('cart/change.js', { id: id, properties: line.properties });

			// Changing properties changes the line key.
			if(updated_cart.items[line_index]){
				$(item).attr('data-item-id', updated_cart.items[line_index].key);
			}
		}catch(error){
			console.error(error);
		}
	});

	/*** WHOLESALE AND BANNER PRODUCTS ***/
	if($('.wholesale_qty').length > 0){
		var qty = $('[data-select-option="quantity"]').val(),
			prev_price = $('#prev_price').val(),
			price = currency(prev_price).multiply(qty);

		if(price.value){
			$('#total_line').show();
			$('#total').text(currency(price).format());
		}else{
			$('#total_line').hide();
		}
	}

	//option_selection
	$(document).on('change', '.option_selection', function(event){
		var selected_options = [],
			this_val = $(this).val(),
			qty = $('.wholesale_qty').val(),
			product_id = $('form[data-product-id]').data('product-id');

		$('.option_selection').each(function(el, selector) {
			var selected = $(this).val();
			selected_options.push(selected);
		});
		
		var selected_variation = $.grep(variations, function(variation) {
			return variation.options.toString() === selected_options.toString();
		});

		if(selected_variation.length){
			$('#product_id').val(selected_variation[0].id);
			$('#product_price').text(Shopify.formatMoney(selected_variation[0].price));

			$('#total').text(Shopify.formatMoney(selected_variation[0].price * qty));

			if($('#prev_price').length > 0){
				$('#prev_price').val(Shopify.formatMoney(selected_variation[0].price));
			}
		
			if(selected_variation[0].featured_image){
				$('#product_main_image').attr('src', selected_variation[0].featured_image.src);
			}
		}else{

			if(product_id == '8218867007688'){
				selected_options[2] = 'Default';
				
				console.log(variations);
				console.log(selected_options);

				//GET BASE PRICE
				var price_selected_variation = $.grep(variations, function(variation) {
					return variation.options.toString() === selected_options.toString();
				});

				console.log(price_selected_variation);
	
				$('#product_price').text(Shopify.formatMoney(price_selected_variation[0].price));
				
				if($('#prev_price').length > 0){
					$('#prev_price').val(Shopify.formatMoney(price_selected_variation[0].price));
				}
			}else{
				$('#product_id').val(0);
	
				selected_options[2] = 'Standard Emboss';
				
				//GET BASE PRICE
				var price_selected_variation = $.grep(variations, function(variation) {
					return variation.options.toString() === selected_options.toString();
				});
	
				$('#product_price').text(Shopify.formatMoney(price_selected_variation[0].price));
				
				if($('#prev_price').length > 0){
					$('#prev_price').val(Shopify.formatMoney(price_selected_variation[0].price));
				}
			}
		}

		var price_multiplier_var = $(this).data('select-option');

		if($('[data-price-multiplier-select="'+ price_multiplier_var +'"]').length){
			$('[data-price-multiplier-select="'+ price_multiplier_var +'"]').val(this_val).change();          
		}
	});

	//data-select-option
	$(document).on('change', '[data-select-option="print-ready-file"]', function(event){
		var v = $(this).val();
		
		if(v == 'I have a print ready file'){
			$('#optional_upload_file').slideDown();
		}else{
			$('#optional_upload_file').slideUp();
		}
	});

	if($('[data-select-option="print-ready-file"]').length > 0){
		var v = $('[data-select-option="print-ready-file"]').val();
		
		if(v == 'I have a print ready file'){
			$('#optional_upload_file').show();
		}else{
			$('#optional_upload_file').hide();
		}
	}

	//data-select-option="sides": the Side 2 artwork picker is only for double sided
	function toggleUploadSide2(){
		var select = $('[data-select-option="sides"]');
		if(!select.length) return;

		$('[data-upload-side-2]').prop('hidden', select.val() != 'Double Sided');
	}

	$(document).on('change', '[data-select-option="sides"]', toggleUploadSide2);
	toggleUploadSide2();

	// ARTWORK GATE
	// Product forms with <artwork-actions> pickers (snippets/artwork-actions) keep Add to Cart
	// disabled until every visible picker has artwork. A hidden picker (single sided, no print
	// ready file) isn't required, and its artwork inputs are disabled so they aren't submitted.
	// Calculator PDPs (<sd-product-form>) are left out: their one button opens the picker
	// until artwork is chosen (assets/sd-pdp.js).
	var ARTWORK_FORMS = 'form:has(artwork-actions)';

	function isArtworkForm(form){
		return Boolean(form.querySelector('artwork-actions')) && !form.closest('sd-product-form');
	}

	function pickerShown(picker, form){
		// <artwork-actions> itself is display: contents, so start from its parent.
		for(var el = picker.parentElement; el && el !== form.parentElement; el = el.parentElement){
			if(el.hidden || getComputedStyle(el).display == 'none') return false;
		}
		return true;
	}

	// The hidden inputs <artwork-actions> writes onto the form once artwork is chosen.
	function pickerInputs(picker, form){
		return ['property-name', 'property-name-hidden'].map(function(attr){
			return form.querySelector('input[name="properties['+ picker.getAttribute(attr) +']"]');
		}).filter(Boolean);
	}

	// Returns the first visible picker still missing artwork, or null when the form is ready.
	function updateArtworkGate(form){
		var missing = null;

		form.querySelectorAll('artwork-actions').forEach(function(picker){
			var shown = pickerShown(picker, form),
				inputs = pickerInputs(picker, form);

			inputs.forEach(function(input){ input.disabled = !shown; });

			if(shown && !missing && !inputs.some(function(input){ return input.value; })){
				missing = picker;
			}
		});

		$(form).find('button:not([type]), button[type="submit"], input[type="submit"]')
			.not('artwork-actions *')
			.prop('disabled', Boolean(missing))
			.attr('title', missing ? 'Please upload your artwork first' : null);

		return missing;
	}

	$(ARTWORK_FORMS).each(function(){
		if(isArtworkForm(this)) updateArtworkGate(this);
	});

	// <artwork-actions> writes its inputs before the event bubbles up to the form.
	$(document).on('artwork:selected', ARTWORK_FORMS, function(){
		if(isArtworkForm(this)) updateArtworkGate(this);
	});

	// Option changes can show or hide a picker, sometimes with a slide: re-check once it settles.
	// A native listener, so it still runs when an earlier jQuery change handler throws.
	document.addEventListener('change', function(event){
		var form = event.target instanceof Element ? event.target.closest('form') : null;
		if(!form || !isArtworkForm(form)) return;

		setTimeout(function(){
			$(form).find(':animated').promise().done(function(){ updateArtworkGate(form); });
		});
	});

	// Backstop for submits that bypass the disabled button (e.g. Enter in a field): runs in the
	// capture phase, ahead of the jQuery submit handlers, and opens the missing picker instead.
	document.addEventListener('submit', function(event){
		var form = event.target;
		if(!(form instanceof HTMLFormElement) || !isArtworkForm(form)) return;

		var missing = updateArtworkGate(form);
		if(!missing) return;

		event.preventDefault();
		event.stopImmediatePropagation();
		if(typeof missing.openUpload == 'function') missing.openUpload();
	}, true);

	// RE-ORDER PREFILL
	// "Re-order" on the account profile (sections/account-profile) links back to the product with
	// the previous configuration in the query string: ?variant=…&quantity=…&prefill=1&properties[…]=…
	// Restores it on the product form with the stickerbros helpers (@theme/product-reorder-prefill,
	// mapped in snippets/artworks-scripts). Calculator PDPs restore themselves (assets/sd-pdp.js).
	function prefillProductForm(prefill){
		var params = prefill.read().params,
			form = $('form[action$="/cart/add"]').filter(function(){ return !this.closest('sd-product-form'); })[0];
		if(!form) return;

		var fireChange = function(el){ el.dispatchEvent(new Event('change', { bubbles: true })); };

		// Variant: the option selects, which the option_selection handler maps back to the variant.
		// Set them all before firing change, so the handler never sees a half-applied combination.
		var variant_id = params.get('variant'),
			variant = variant_id && window.variations ? $.grep(window.variations, function(v){ return String(v.id) === variant_id; })[0] : null,
			option_selects = [];

		if(variant){
			variant.options.forEach(function(value, index){
				var select = form.querySelector('select.option_selection[name="option'+ (index + 1) +'"]');
				if(select && $(select).find('option').filter(function(){ return this.value === value; }).length){
					select.value = value;
					option_selects.push(select);
				}
			});
			$(form).find('[name="id"]').val(variant_id);
			option_selects.forEach(fireChange);
		}else if(variant_id){
			// Variant picker without option selects (e.g. the deal page's finish select).
			$(form).find('select[name="id"]').filter(function(){ return $(this).find('option[value="'+ variant_id +'"]').length; }).val(variant_id).each(function(){ fireChange(this); });
		}

		var quantity = params.get('quantity'),
			quantity_input = form.querySelector('[name="quantity"]');
		if(quantity && quantity_input && quantity_input.type != 'hidden'){
			if(!(quantity_input instanceof HTMLSelectElement) || $(quantity_input).find('option').filter(function(){ return this.value === quantity; }).length){
				quantity_input.value = quantity;
				fireChange(quantity_input);
			}
		}

		// applyProperties only adds the _Reorder input to a <form> inside the root it's given.
		if(params.has('properties[_Reorder]') && !form.querySelector('[name="properties[_Reorder]"]')){
			$('<input type="hidden" name="properties[_Reorder]">').appendTo(form);
		}

		// Remaining properties (text fields, extra options), then the artwork, which re-runs the
		// artwork gate through artwork:selected.
		prefill.applyProperties(form, params);
		prefill.applyArtwork(form, params);
	}

	if(new URLSearchParams(window.location.search).get('prefill') === '1'){
		import('@theme/product-reorder-prefill')
			.then(prefillProductForm)
			.catch(function(error){ console.error('[re-order] prefill failed:', error); });
	}

	//WHOLE SALE BUNDLE PRICE
	$(document).on('change', '.wholesale_qty', function(event){
		if($('[data-select-option="bundle-price"]').length > 0){
			var v = $(this).val(),
				bundle = v >= 6 ? '6+' : '1-5';
			
			$('[data-select-option="bundle-price"]').val(bundle).change();
		}

		var qty = parseInt($(this).val()),
			prev_price = $('#prev_price').val(),
			extra_fee = $('#extra_fee').val(),
			price = currency(prev_price).multiply(qty).add(extra_fee),
			min = parseInt($('.wholesale_qty').attr('min'));

		if(price.value){
			$('#total_line').show();
			$('#total').text(currency(price).format());
		}else{
			$('#total_line').hide();
		}

		// Minimum quantity
		if(qty < min) $(this).val(min);
	});

	$(document).on('change', '[data-select-option="quantity"]', function(event){
		var qty = $(this).find(':selected').data('qty-value');
		$('.wholesale_qty').val(qty).change();
	});

	if($('.icepick_wholesale').length > 0 && $('#option1').length){
		$('.wholesale_qty').trigger('change');
	}
	
	if($('#wholesale_material_options').length){
		var materials = $('#wholesale_material_options').data('materials'),
			html = '';
		
		$.each(materials, (option, values) => {
			html += '<div class="d-none">'+
						'<select name="properties['+option+']" data-price-multiplier-select="'+ option.toLowerCase() +'">';

						$.each(values, (key, value) => {
							html += '<option value="'+ key +'" data-price-multiplier="'+ value +'">'+ key +'</option>';
						});

			html += '</select></div><input type="hidden" id="price_multiplier" name="price_multiplier" value="0">';
		});

		$('#wholesale_material_options').html(html);
	}

	//data-price-multiplier
	$(document).on('change', '[data-price-multiplier-select]', function(event){
		var multiplier = $(this).find(':selected').data('price-multiplier'),
			price = $('#prev_price').val();

		$('#price_multiplier').val(multiplier).change();

		price = currency(price).multiply(multiplier).format();

		$('#product_price').text(price);
	});
	
	//api_form
	$(document).on('submit', '.api_form', async function(event){
		if($('#product_id').val() == 0){
			event.preventDefault();
			
			var form_data = $(this).serializeJSON(),
				now = Date.now();

			try{
				const obj = JSON.parse(await formRequest('https://icepick.co/api/shopify/wholesale.php?v='+ now, 'POST', { form_data: form_data }));
				$('#product_id').val(obj.variant.id);
			}catch(error){
				console.error(error);
			}
		}
	});

	//CUSTOM PRICING FORM
	function updateTotalCustomPricing() {
		var qty = parseInt($('input[name="quantity"]').val()) || 0;
		var unit = parseFloat(($('input[name="prev_price"]').val() || "0").replace(/[^0-9.]/g, ''));
		var extra = parseFloat($('input[name="extra_fee"]').val() || 0);
		var total = (qty * unit) + extra;

		$('#total').text('$' + total.toFixed(2));
		// Actualiza el campo oculto final_price si existe
		if($('input[name="final_price"]').length){
			$('input[name="final_price"]').val(total.toFixed(2));
		}
	}

	$(document).on('input change', '.custom_pricing_form input[name="quantity"], .custom_pricing_form input[name="prev_price"], .custom_pricing_form input[name="extra_fee"], .custom_pricing_form .option_selection', updateTotalCustomPricing);
	$(document).ready(updateTotalCustomPricing);

	function generateRandomString(length) {
		var chars = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
		var result = '';
		for (var i = 0; i < length; i++) {
			result += chars.charAt(Math.floor(Math.random() * chars.length));
		}
		return result;
	}

	$(document).on('submit', '.custom_pricing_form', async function(event){
		event.preventDefault();
		var form = $(this);
		var form_data = form.serializeJSON(),
			now = Date.now();

		// Calcula y asegura que los campos prev_price y final_price estén correctos
		var qty = parseInt(form_data.quantity) || 0;
		var unit = parseFloat((form_data.prev_price || "0").replace(/[^0-9.]/g, ''));
		var extra = parseFloat(form_data.extra_fee || 0);
		var total = (qty * unit) + extra;
		form_data.prev_price = unit.toFixed(2);
		form_data.final_price = total.toFixed(2);

		// Asignar un valor random a option3 (Design) si no existe
		if(!form_data.option3){
			form_data.option3 = generateRandomString(12);
		}

		// Flujo estándar de Shopify: POST a /cart/add.js con la variante del formulario
		async function addDefaultVariant(){
			try{
				await cartRequest('cart/add.js', {
					id: form_data.id || form_data["product_id"] || form_data["product-id"],
					quantity: 1, // Siempre 1
					// Keep the form's properties (uploaded artwork, extra text) on the line.
					properties: Object.assign({}, form_data.properties, {
						"Quantity": qty
					})
				});
				await $.fn.openCartDrawer();
			}catch(error){
				alert('Error adding product to cart.');
			}
		}

		// Si option3 es 'Default', usar flujo estándar de Shopify
		if(form_data.option3 === 'Default'){
			addDefaultVariant();
			return;
		}

		// Si option3 es custom, usar la API custom
		let data;
		try{
			data = await formRequest('https://api.icepick.co/shopify/custompricing.php?v='+ now, 'POST', { form_data: form_data });
		}catch(error){
			let msg = 'Server error. Please try again.';
			if(error.responseText){
				try {
					const obj = JSON.parse(error.responseText);
					// Mostrar logs de debug si existen
					if(obj.debug && Array.isArray(obj.debug)){
						console.log('DEBUG LOGS:', obj.debug);
					}
					if(obj.error) msg = obj.error;
				} catch(e){}
			}
			alert(msg);
			return;
		}

		let obj;
		try {
			obj = JSON.parse(data);
		} catch (e) {
			alert('Unexpected server response. Please try again.');
			return;
		}
		// Mostrar logs de debug si existen
		if(obj.debug && Array.isArray(obj.debug)){
			console.log('DEBUG LOGS:', obj.debug);
		}
		if(obj.status === 'default_variant'){
			// Respaldo: si la API responde que es default, usar flujo estándar
			addDefaultVariant();
			return;
		}
		if(obj.variant && obj.variant.id){
			$('#product_id').val(obj.variant.id);
			// Agregar la nueva variante custom al carrito
			try{
				await cartRequest('cart/add.js', {
					items: [
						{
							id: obj.variant.id,
							quantity: 1, // Siempre 1
							properties: {
								"Quantity": qty
							}
						}
					]
				});
				await $.fn.openCartDrawer();
			}catch(error){
				console.error(error);
			}
		} else if(obj.error){
			alert('Error: ' + obj.error);
		} else {
			alert('Unexpected error. Please try again.');
		}
	});

	//data-open-deals-lightbox
	$(document).on('click', '[data-open-deals-lightbox]', function(event){
		event.preventDefault();
		$('#confirmation_lightbox').addClass('open_lightbox');
	});
	
	//data-form-onetimedeal
	$(document).on('submit', '#onetimedeal_form', async function(event){
		event.preventDefault();
			
		var form = $(this),
			email = $(form).find('[name="account_email"]').val(),
			product = $(form).find('[name="product_id"]').val();

		$(form).addClass('loading');

		try{
			const data = JSON.parse(await formRequest('https://icepick.co/api/shopify/onetimedeal.php', 'POST', { email: email, product: product }));

			if(data.status == 'error'){
				alert('Unexpected error. Please try again later');
			}

			if(data.status == 'already_purchased'){
				$('#onetimedeal_form').hide();
				$('#onetimedeal_already_purchased').show();
			}

			if(data.status == 'success'){
				$('#onetimedeal_form').hide();
				$('#onetimedeal_product_form').show();
			}
		}catch(error){
			console.error(error);
		}finally{
			$(form).removeClass('loading');
		}
	});

	//mobile_has_children
	$(document).on('click', '.mobile_has_children', function(event){
		event.preventDefault();

		if($(this).hasClass('open')){
			$(this).removeClass('open');
			$(this).next('.mobile_submenu').slideUp();
		}else{
			$(this).addClass('open');
			$(this).next('.mobile_submenu').slideDown();
		}
	});

	//data-open-chat
	$(document).on('click', '[data-open-chat]', function(event){
		event.preventDefault();
		document.querySelector("#dummy-chat-button-iframe").contentWindow.document.querySelector('.chat-toggle').click();
	});

	//rush_option_header
	$(document).on('click', '.rush_option_header', function(event){
		if($(this).hasClass('open')){
			$(this).removeClass('open');
			$('.rush_option_body').slideUp();
		}else{
			$(this).addClass('open');
			$('.rush_option_body').slideDown();
		}
	});

	//rush_option
	$.fn.addRushOption = async function(rush_option){
		if(rush_option == 'standard') return;
		
		var items = $('.cart_item:not(.product_rush-option)'),
				subtotal = 0,
				now = Date.now();

		$.each(items, function(idx, item){
			var price = $(item).find('.discounted_price').lenght > 0 ? $(item).find('.discounted_price').text() : $(item).find('.original_price').text();
			subtotal = currency(subtotal).add(price).value;
		});
		
		if(!subtotal) return;

		$('#cart_sidebar').addClass('loading');

		try{
			const obj = JSON.parse(await formRequest('https://icepick.co/api/shopify/rushoption.php?v='+ now, 'POST', { subtotal: subtotal, rush_option: rush_option }));

			if(obj.status != 'success'){
				alert(obj.error || 'An unexpected error occurred, please verify your data and try again');
				return;
			}

			const items = obj.items.filter((element) => element.id !== 0 && element.id != null);
			const added_item = (await cartRequest('cart/add.js', { items: items })).items[0];

			var obj_html = '<div class="cart_item row py-4 align-items-start product_rush-option product_rush-option" data-item-id="'+ added_item.key +'">'+
								'<div class="col-12">'+
									'<div class="row">'+
										'<div class="col-8">'+
											'<span class="cart_item_title d-block">Rush Option</span>'+
											'<ul class="cart_item_attr">'+
												'<li>Production time:<br>'+ added_item.properties.RushOption +'</li>'+
												'<input type="hidden" id="selected_rush_option" value="'+ added_item.properties.nude_rushoption +'">'+
											'</ul>'+
										'</div>'+
										'<div class="col-4 text-end"><span class="hulkapps-cart-item-line-price" data-key="'+ added_item.key +'"><span class="original_price">'+ Shopify.formatMoney(added_item.final_price) +'</span></span></div>'+
									'</div>'+
									'<div class="row">'+
										'<div class="col-8"></div>'+
										'<div class="col-4">'+
											'<span class="cart_item_remove d-block text-end" data-remove-cart-item="">Remove</span>'+
										'</div>'+
									'</div>'+
								'</div>'+
							'</div>';
			
			$('#cart_body').append(obj_html);

			$('.rush_option_accordeon').hide();
			$('.rush_option_body').hide();
			$('.rush_option_header').removeClass('open');
			
			setTimeout(async ()=>{
				const cart = await cartRequest('cart.js');
				$('.subtotal_amount').text(Shopify.formatMoney(cart.total_price));
				$('.grand_total_amount').text(Shopify.formatMoney(cart.total_price));
			}, 500);
		}catch(error){
			console.error(error);
			alert('An unexpected error occurred, please verify your data and try again');
		}finally{
			$('#cart_sidebar').removeClass('loading');
		}
	}

	//CLICK RUSH OPTION RADIOS
	$(document).on('click', '.rush_option', function(event){
		var rush_option = $(this).val();
		$.fn.addRushOption(rush_option);
	});

	$.fn.addRushOptionClick = function(option){
		$('[value="'+ option +'"]').click();
	}

	if($('.cart_is_empty').length){
		cartRequest('cart.js').then((cart) => {
			if(cart.total_price){
				localStorage.setItem('stickerbors_lpv', 'cart');
				location.reload();
			}
		}).catch((error) => console.error(error));
	}

	//acordion_header
	$('.acordion_header').on('click', function(){
		var item = $(this).closest('.acordion_item'),
			content = item.find('.acordion_body');
		
		if($(item).hasClass('open')){
			$(item).removeClass('open');
			content.slideUp();
		}else{
			$('.acordion_item').removeClass('open');
			$('.acordion_body').slideUp();
			
			item.addClass('open');
			content.slideDown();
		}
	});

	/*** SPECIAL CASES ***/
	if($('#product_form_8218867007688').length > 0){
		var finish = $('[data-select-option="finish"]').val();
		var extra_fee = finish == 'Spot Gloss' || finish == 'HD Embossing' ? 10 : 0;
		
		$(document).on('change', '[data-select-option="finish"]', function(event){
			finish = $('[data-select-option="finish"]').val();
			extra_fee = finish == 'Spot Gloss' || finish == 'HD Embossing' ? 10 : 0;
			$('#extra_fee').val(extra_fee).change();
			$('#extra_fee_line').toggle(extra_fee > 0);

			if(extra_fee > 0){
				$('#option3').val(Math.random().toString(36).substring(2, 15));
			}else{
				$('#option3').val('Default');
			}
		});
	}

});